import { render, staticRenderFns } from "./ApprovalReject.vue?vue&type=template&id=75ad8830&scoped=true"
import script from "./ApprovalReject.vue?vue&type=script&lang=js"
export * from "./ApprovalReject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ad8830",
  null
  
)

export default component.exports